import { render } from "./ledger.vue?vue&type=template&id=ee8e7bd6&scoped=true"
import script from "./ledger.vue?vue&type=script&lang=js"
export * from "./ledger.vue?vue&type=script&lang=js"

import "./ledger.vue?vue&type=style&index=0&id=ee8e7bd6&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8e7bd6"]])

export default __exports__